import getDialog from './active-dialog';
import getDialogProps from './dialog-props';

export default {
  getDialog,
  getDialogProps,
};
